'use client';

import { useState, useEffect } from 'react';
import { getStoredToken, clearToken, authHeaders } from '@/lib/auth';

interface AuthState {
  isAuthenticated: boolean;
  loading: boolean;
  user?: { role: string; workspace_id: string | null };
}

export function useAuth(): AuthState {
  const [authState, setAuthState] = useState<AuthState>({
    isAuthenticated: false,
    loading: true,
  });

  useEffect(() => {
    const token = getStoredToken();
    if (!token) {
      setAuthState({ isAuthenticated: false, loading: false });
      return;
    }

    let alive = true;
    (async () => {
      try {
        const res = await fetch('/api/me', { headers: authHeaders() });
        if (!alive) return;
        if (res.ok) {
          const data = await res.json().catch(() => ({}));
          setAuthState({
            isAuthenticated: true,
            loading: false,
            user: { role: data.role, workspace_id: data.workspace_id ?? null },
          });
        } else {
          if (res.status === 401 || res.status === 403) clearToken();
          setAuthState({ isAuthenticated: false, loading: false });
        }
      } catch {
        if (!alive) return;
        setAuthState({ isAuthenticated: false, loading: false });
      }
    })();
    return () => { alive = false; };
  }, []);

  return authState;
}

export async function logout() {
  clearToken();
  if (typeof window !== 'undefined') window.location.href = '/login';
}
